module.exports = __webpack_public_path__ + "static/media/davana.5ae5759a.svg";